// Core
import { renderToString } from 'react-dom/server';
import { GetStaticPaths, GetStaticProps, GetStaticPropsContext } from 'next';
import { getServerState } from 'react-instantsearch';

import { isEnableServer } from '@virginexperiencedays/feature-flags';

// CMS
import { documentTypes } from '@virginexperiencedays/cms/constants';

// Constants
import {
  categoryPrefixes,
  categoryTypes,
  indexNames,
} from '@virginexperiencedays/search/constants';

// Internal
import CategoryListingPage from '../../../../components/pages/search/CategoryListingPage';
import type { CategoryListingPageType } from '../../../../components/pages/search/CategoryListingPage/types';
import { PageContext } from '../../../../components/PageContext';

import { listingPagePropsExtractor } from '../../../../utils/search/listingPagePropsExtractor';

// @TODO: Remove
import { previewOccasionPages } from '../../[...slug]';
import { isValidResultPage } from '../../../../utils/algolia/isValidResultPage';
import { ISR_CONTROL } from '../../../../constants/revalidate';

export const getStaticProps: GetStaticProps<CategoryListingPageType> = async ({
  params,
  preview,
  previewData,
}: GetStaticPropsContext) => {
  const baseProps = await listingPagePropsExtractor({
    documentType: documentTypes.OCCASION,
    params,
    preview,
    previewData,
    categoryPrefix: categoryPrefixes.OCCASION,
    categoryType: categoryTypes.OCCASION,
  });

  if (!baseProps?.prismicPage) {
    return {
      notFound: true,
    };
  }

  // Search
  const serverState = await getServerState(
    <PageContext>
      <CategoryListingPage
        initialNavItems={baseProps.initialNavItems}
        topProducts={baseProps.topProducts}
        categoryPrefix={baseProps.categoryPrefix}
        categoryType={baseProps.categoryType}
        url={baseProps.url}
        slug={baseProps.slug}
        prismicPage={baseProps.prismicPage}
        prismicSlices={baseProps.prismicSlices}
        locationOverrides={baseProps.locationOverrides}
      />
    </PageContext>,
    { renderToString }
  );

  const isValidResult = isValidResultPage({
    serverState,
    index: indexNames.DEFAULT,
    currentPage: baseProps.page,
  });

  if (baseProps.page && !isValidResult) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      ...baseProps,
      serverState,
    },
    revalidate: ISR_CONTROL.ONCE_PER_DAY,
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  if (!isEnableServer('FF_limited_deployments')) {
    return {
      paths: previewOccasionPages.map((path) => `/${categoryPrefixes.OCCASION}/page/2/${path}`),
      fallback: 'blocking',
    };
  }
  //@TODO: Paths should be coming from prismic
  return {
    paths: previewOccasionPages.map((path) => `/${categoryPrefixes.OCCASION}/page/2/${path}`),
    fallback: 'blocking',
  };
};

export default CategoryListingPage;
